import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {deleteCall, getCall, postCall} from "../../utils/api";

const initialState = {
    data: {
        records: [],
        pagination: null
    },
    error: "",
    status: "idle",
    processStatus: "idle",
    detectStatus: "idle",
    cleanUpStatus: "idle"
};

export const getDuplicates = createAsyncThunk(
    "outletDuplicate/get",
    async ({ page = 1, per_page = 10, query = "" }) => {
        try {
            const response = await getCall(
                `/admin/v1/duplicates/all?page=${page}&per_page=${per_page}${query ? `&query=${query}` : ''}`,
                false
            );
            return await response;
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

export const processDuplicates = createAsyncThunk(
    "outletDuplicate/process",
    async (processData, { rejectWithValue }) => {
        try {
            const response = await postCall("/admin/v1/duplicates/start", processData)
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const detectDuplicates = createAsyncThunk(
    "outletDuplicate/detect",
    async (_, { rejectWithValue }) => {
        try {
            const response = await getCall("/admin/v1/duplicates/detect", false);
            return await response;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export const cleanUpDuplicates = createAsyncThunk(
    "outletDuplicate/cleanUp",
    async (_, { rejectWithValue }) => {
        try {
            const response = await deleteCall("/admin/v1/duplicates/clean-up", false);
            return await response;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

const OutletDuplicateSlice = createSlice({
    name: "outletDuplicate",
    initialState,
    reducers: {
        setOutletDuplicateLoading: (state, action) => {
            state.status = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDuplicates.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getDuplicates.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data.records = action.payload.data.data;
                state.data.pagination = action.payload.data.pagination;
            })
            .addCase(getDuplicates.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message || "An unknown error occurred";
            })
            .addCase(processDuplicates.pending, (state) => {
                state.processStatus = "loading";
            })
            .addCase(processDuplicates.fulfilled, (state) => {
                state.processStatus = "succeeded";
            })
            .addCase(processDuplicates.rejected, (state, action) => {
                state.processStatus = "failed";
                state.error = action.error.message || "An unknown error occurred";
            })
            .addCase(detectDuplicates.pending, (state) => {
                state.detectStatus = "loading";
            })
            .addCase(detectDuplicates.fulfilled, (state) => {
                state.detectStatus = "succeeded";
            })
            .addCase(detectDuplicates.rejected, (state, action) => {
                state.detectStatus = "failed";
                state.error = action.error.message || "An unknown error occurred";
            })
            .addCase(cleanUpDuplicates.pending, (state) => {
                state.cleanUpStatus = "loading";
            })
            .addCase(cleanUpDuplicates.fulfilled, (state) => {
                state.cleanUpStatus = "succeeded";
            })
            .addCase(cleanUpDuplicates.rejected, (state, action) => {
                state.cleanUpStatus = "failed";
                state.error = action.error.message || "An unknown error occurred";
            });
    },
});

export const { setOutletDuplicateLoading } = OutletDuplicateSlice.actions;

export default OutletDuplicateSlice.reducer;